import { render } from "./WhatHappening.vue?vue&type=template&id=6b4aceaa&ts=true"
import script from "./WhatHappening.vue?vue&type=script&lang=ts"
export * from "./WhatHappening.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__